import { Controller } from "@hotwired/stimulus"

// P41 — Les terrains proposés suivent le club choisi. Sans JavaScript,
// tous les groupes restent visibles et le serveur ne retient de toute
// façon que les terrains du club retenu : l'affichage n'est qu'un
// confort.
export default class extends Controller {
  static targets = ["groupe"]
  static values = { select: String }

  connect() {
    this.select = document.getElementById(this.selectValue)
    if (!this.select) return

    this.suivre = () => this.afficherLeGroupe()
    this.select.addEventListener("change", this.suivre)
    this.afficherLeGroupe()
  }

  disconnect() {
    if (this.select && this.suivre) this.select.removeEventListener("change", this.suivre)
  }

  afficherLeGroupe() {
    const choisi = this.select.value
    this.groupeTargets.forEach((groupe) => {
      groupe.hidden = choisi !== "" && groupe.dataset.terrainsClub !== choisi
    })
  }
}
